<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" @close="close" class="w-[90%] desktop:w-[70%]">

    <div class="flex gap-x-8 gap-y-8 justify-center flex-wrap">

      <div>
        <MoleculesDynamicInspirationPhoto class="!-mb-1" image-class="max-h-[80vh]" :id="dialog?.data.id" :fileType="dialog?.data.fileType" :links="dialog?.data.links" :is-detail="true" />
      </div>

      <div class="flex-1 min-w-[300px]">
        <AtomsTextHeading>{{ $t('Produkty z fotografie') }}</AtomsTextHeading>

        <div class="inspiration-detail">
          <AtomsTextLink v-for="item in wareItems" :href="item.url" target="_blank" class="inspiration-detail__item" data-pageelementname="photo_gallery_inspiration_ware_link">
            <MoleculesGlobalWareImage :ware-name="item.entity.name" :image-id="item.entity.image?.id" suffix="pl" />
            <div class="flex flex-col items-between gap-2 font-bold">
              <div>{{ item.entity.name }}</div>
              {{ (item.entity.price.minPrice.afterCustomerSale !== item.entity.price.maxPrice.afterCustomerSale ? $t('od') + ' ' : '') + item.entity.price.minPrice.afterCustomerSaleFormatted }}
            </div>
          </AtomsTextLink>
        </div>
      </div>

    </div>

  </AtomsGlobalDialog>
</template>
<script setup>

const dialog = computed(() => useDialog().get('inspirationDetail'));

const close = () => useDialog().close();

const wareItems = computed(() => {
  return dialog.value?.data?.links.map(link => link.page) || [];
});

</script>
<style lang="postcss">
.inspiration-detail {

  @apply mt-4;

  &__item {
    @apply flex gap-6 py-4 border-b border-neutral-200 tracking-normal hover:no-underline;

    img {
      @apply max-w-[60px] max-h-[60px];
    }

    &:last-of-type {
      @apply border-b-0;
    }
  }
}
</style>